import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../utils/storage/storage.service';
import { catchError, from, map, Observable, of, switchMap } from 'rxjs';
import { PermissionsService } from '../services/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class TokenGuard implements CanActivate {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private storageService: StorageService,
    private permissionsService: PermissionsService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.authService.hasTokenAndUserDetails()).pipe(
      switchMap((hasDetails: boolean) => {
        if (hasDetails) {
          return this.checkTokenFromLocalStorage();
        }
        this.authService.redirectToLogin();
        return of(false);
      })
    );
  }

  checkTokenFromLocalStorage(): Observable<boolean> {
    return from(this.authService.getToken()).pipe(
      switchMap((token: string | null) => {
        if (token) {
          return this.authService.verifyToken(token).pipe(
            map((isValid: boolean) => {
              if (isValid) {
                // get the permissions after we have a valid token, otherwise we will get 401
                this.permissionsService.storeUserPermissions();

                return true;
              } else {
                this.authService.redirectToLogin();
                return false;
              }
            }),
            catchError(() => of(false))
          );
        } else {
          this.authService.redirectToLogin();
          return of(false);
        }
      }),
      catchError(() => of(false))
    );
  }
}
